import React from 'react'

import { Media } from '~/components'

import Desktop from './index.desktop'
import Mobile from './index.mobile'

const Header = props => {
  return <Media desktop={<Desktop {...props} />} mobile={<Mobile {...props} />} />
}

export default Header
